"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.version = exports.language = exports.compareVersion = exports.other = exports.pc = exports.android = exports.ios = void 0;

var env_1 = require("./env"),
    ENV = env_1.getENV();

exports.ios = ENV.platform === env_1.ENV_ENUM.ios, exports.android = ENV.platform === env_1.ENV_ENUM.android, exports.pc = ENV.platform === env_1.ENV_ENUM.pc, exports.other = ENV.platform === env_1.ENV_ENUM.notInDingTalk, exports.compareVersion = function (e, r, t) {
  function o(e) {
    return parseInt(e, 10) || 0;
  }

  if ("string" != typeof e || "string" != typeof r) return !1;

  for (var s, p, n = e.split("-")[0].split(".").map(o), i = r.split("-")[0].split(".").map(o); s === p && i.length > 0;) {
    s = n.shift(), p = i.shift();
  }

  return t ? (p || 0) >= (s || 0) : (p || 0) > (s || 0);
}, exports.language = ENV.language, exports.version = ENV.version;